import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import UserView from '../views/UserView.vue'
import CotizacionView from '../views/CotizacionView.vue'
import DetalleCotizacionView from '../views/DetalleCotizacionView.vue'
import EditarCotizacionView from '../views/EditarCotizacionView.vue'
import SolicitudInspeccionView from '../views/SolicitudInspeccionView.vue'
import DetalleSolicitudesView from '../views/DetalleSolicitudesView.vue'
import DetalleInspeccionView from '../views/DetalleInspeccionView.vue'
import InformacionGeneralInspeccionView from '../views/InformacionGeneralInspeccionView.vue'


const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
   

  },
  {
    path: '/inicio',
    name: 'inicio',
    component: HomeView,
    meta: { requiresAuth: true}
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: UserView,
    meta: { requiresAuth: true}
  },
  {
    path: '/cotizacion',
    name: 'cotizacion',
    component: CotizacionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/mostrarcotizacion',
    name: 'mostrarcotizacion',
    component: DetalleCotizacionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/solicitudinspeccion',
    name: 'solicitudinspeccion',
    component: SolicitudInspeccionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/editarcotizacion',
    name: 'editarcotizacion',
    component: EditarCotizacionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/detallesolicitud',
    name: 'detallesolicitud',
    component: DetalleSolicitudesView,
    meta: { requiresAuth: true}
  }, 
  {
    path: '/detalleinspeccion',
    name: 'detalleinspeccion',
    component: DetalleInspeccionView,
    meta: { requiresAuth: true}
  },
  {
    path: '/informaciongeneralinspeccion',
    name: 'informaciongeneralinspeccion',
    component: InformacionGeneralInspeccionView,
    meta: { requiresAuth: true}
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('accessToken');
  //const userRoles = store.state.auth.roles; // Accede al estado de los roles del usuario
  //alert(userRoles + 'roles');
  var val = !isAuthenticated;
  if (to.meta.requiresAuth == true && isAuthenticated == null ) {
    next({ name: 'login' });
  } else  /*(to.meta.requiresAuth && isAuthenticated)*/ {
    next();
  } 
});

export default router
